import React from "react";
import HeatmapLayer from "components/HeatmapLayer";

function HeatMapLayers({ points, options, leafletMap }) {
  if (!points || !leafletMap?.leafletElement) {
    return null;
  }

  return (
    <HeatmapLayer
      points={points}
      map={leafletMap?.leafletElement}
      options={options}
    />
  );
}

export default HeatMapLayers;
